import React, { lazy } from "react";
import { Route } from "react-router-dom";

const RBACDashboardPage = lazy(() => import("../pages/admin/rbac/RBACDashboardPage"));
const RoleManagerPage = lazy(() => import("../pages/admin/rbac/RoleManagerPage"));
const PermissionManagerPage = lazy(() => import("../pages/admin/rbac/PermissionManagerPage"));
const PermissionMatrixPage = lazy(() => import("../pages/admin/rbac/PermissionMatrixPage"));
const RoleAssignmentPage = lazy(() => import("../pages/admin/rbac/RoleAssignmentPage"));
const PermissionAuditPage = lazy(() => import("../pages/admin/rbac/PermissionAuditPage"));
const PermissionSimulatorPage = lazy(() => import("../pages/admin/rbac/PermissionSimulatorPage"));

const UserDashboardPage = lazy(() => import("../pages/admin/users/UserDashboardPage"));
const UserDirectoryPage = lazy(() => import("../pages/admin/users/UserDirectoryPage"));
const UserProfilePage = lazy(() => import("../pages/admin/users/UserProfilePage"));
const UserImportPage = lazy(() => import("../pages/admin/users/UserImportPage"));
const UserExportPage = lazy(() => import("../pages/admin/users/UserExportPage"));
const DepartmentManagerPage = lazy(() => import("../pages/admin/users/DepartmentManagerPage"));
const OrganizationPage = lazy(() => import("../pages/admin/users/OrganizationPage"));
const CampusManagerPage = lazy(() => import("../pages/admin/users/CampusManagerPage"));
const AcademicStructurePage = lazy(() => import("../pages/admin/users/AcademicStructurePage"));
const ProfileSettingsPage = lazy(() => import("../pages/admin/users/ProfileSettingsPage"));

const RolesPage = lazy(() => import("../pages/RolesPage").then(m => ({ default: m.RolesPage })));
const RoleDetailsPage = lazy(() => import("../pages/RoleDetailsPage").then(m => ({ default: m.RoleDetailsPage })));
const PermissionsPage = lazy(() => import("../pages/PermissionsPage").then(m => ({ default: m.PermissionsPage })));
const AssignRolesPage = lazy(() => import("../pages/AssignRolesPage").then(m => ({ default: m.AssignRolesPage })));
const InstitutionTypeManagementPage = lazy(() => import("../pages/master/InstitutionTypeManagementPage"));
const UniversityManagementPage = lazy(() => import("../pages/master/UniversityManagementPage"));
const MasterDepartmentManagementPage = lazy(() => import("../pages/master/DepartmentManagementPage"));

export const renderAdminRoutes = () => (
  <>
    {/* Master Data Routes */}
    <Route path="/master/institution-types" element={<InstitutionTypeManagementPage />} />
    <Route path="/admin/master/institution-types" element={<InstitutionTypeManagementPage />} />
    <Route path="/master/universities" element={<UniversityManagementPage />} />
    <Route path="/admin/master/universities" element={<UniversityManagementPage />} />
    <Route path="/master/departments" element={<MasterDepartmentManagementPage />} />
    <Route path="/admin/master/departments" element={<MasterDepartmentManagementPage />} />

    {/* RBAC Routes */}
    <Route path="/rbac/roles" element={<RolesPage />} />
    <Route path="/rbac/roles/:id" element={<RoleDetailsPage />} />
    <Route path="/rbac/permissions" element={<PermissionsPage />} />
    <Route path="/rbac/matrix" element={<PermissionMatrixPage />} />
    <Route path="/rbac/assign-roles" element={<AssignRolesPage />} />

    {/* Admin RBAC Console Routes */}
    <Route path="/admin/rbac/dashboard" element={<RBACDashboardPage />} />
    <Route path="/admin/rbac/roles" element={<RoleManagerPage />} />
    <Route path="/admin/rbac/permissions" element={<PermissionManagerPage />} />
    <Route path="/admin/rbac/matrix" element={<PermissionMatrixPage />} />
    <Route path="/admin/rbac/assignments" element={<RoleAssignmentPage />} />
    <Route path="/admin/rbac/audit-logs" element={<PermissionAuditPage />} />
    <Route path="/admin/rbac/simulator" element={<PermissionSimulatorPage />} />

    {/* Admin User Management Routes */}
    <Route path="/admin/users/dashboard" element={<UserDashboardPage />} />
    <Route path="/admin/users/directory" element={<UserDirectoryPage />} />
    <Route path="/admin/users/profile" element={<UserProfilePage />} />
    <Route path="/admin/users/import" element={<UserImportPage />} />
    <Route path="/admin/users/export" element={<UserExportPage />} />
    <Route path="/admin/users/departments" element={<DepartmentManagerPage />} />
    <Route path="/admin/users/organization" element={<OrganizationPage />} />
    <Route path="/admin/users/campuses" element={<CampusManagerPage />} />
    <Route path="/admin/users/academic-structure" element={<AcademicStructurePage />} />
    <Route path="/admin/users/settings" element={<ProfileSettingsPage />} />
  </>
);
